import { Skeleton, type SkeletonProps } from '@mui/material';

type Props = SkeletonProps;

export default function ActionButtonSkeleton(props: Props) {
  return (
    <Skeleton
      variant="circular"
      width={40}
      height={40}
      {...props}
    />
  );
}
